import LifestyleSettingsPanel from "./panels/LifestyleSettingsPanel";

const tabRoutes = [
  {
    name: "Lifestyle Settings",
    path: "/settings",
    component: <LifestyleSettingsPanel />
  }
];

export default tabRoutes;
